import { render, staticRenderFns } from "./IncomeFlow.vue?vue&type=template&id=2ba3155c&"
import script from "./IncomeFlow.vue?vue&type=script&lang=js&"
export * from "./IncomeFlow.vue?vue&type=script&lang=js&"
import style0 from "./IncomeFlow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "IncomeFlow.vue"
export default component.exports